export const BRAND = "KAD BISNES";

export const DIREKTORIBIZ_URL = "https://direktoribiz.my";

export const QUANTITIES = [100, 200, 300, 500, 1000];

export const PENINSULAR_STATES = [
  "Johor",
  "Kedah",
  "Kelantan",
  "Melaka",
  "Negeri Sembilan",
  "Pahang",
  "Perak",
  "Perlis",
  "Pulau Pinang",
  "Selangor",
  "Terengganu",
  "W.P. Kuala Lumpur",
  "W.P. Putrajaya",
];

export const EAST_MALAYSIA_STATES = ["Sabah", "Sarawak", "W.P. Labuan"];

export const MY_STATES = [...PENINSULAR_STATES, ...EAST_MALAYSIA_STATES].sort();

export const COUNTRIES = ["Malaysia", "Singapore"];

export const LOGO_CHOICES = {
  HAS: "has_logo",
  NONE: "no_logo",
  NOT_YET: "not_yet",
};

export const CARD_FORMAT = {
  finished: "86mm × 52mm",
  orientation: "Landscape",
  sides: "Depan & Belakang",
};

export const MAX_LOGO_BYTES = 3 * 1024 * 1024;

/** Phase 2A: SVG no longer accepted. */
export const ALLOWED_LOGO_TYPES = ["image/png", "image/jpeg"];

/** Card-facing max lengths, mirrored from the backend models for UX only. */
export const FIELD_LIMITS = {
  namaPenuh: 60,
  jawatan: 60,
  namaPerniagaan: 70,
  bidangBisnes: 90,
  telefon: 20,
  whatsapp: 20,
  email: 90,
  website: 90,
  line1: 80,
  line2: 80,
  postcode: 10,
  city: 50,
};

/**
 * DISPLAY LABEL ONLY. Shipping amounts are calculated by the backend
 * (`POST /api/quote`); the frontend never determines payable amounts.
 */
export const shippingLabelFor = (country, state) => {
  if (country === "Singapore") return "Penghantaran Singapura";
  if (EAST_MALAYSIA_STATES.includes(state)) return "Penghantaran Sabah/Sarawak/Labuan";
  return "Penghantaran";
};
